import SearchBar from "./SearchBar";
import LocalFileImportNav from "./LocalFileImportNav";
import useActionSuccessMessageStore from "../store/actionSuccessMessageStore";
import { useUserContext } from "../contexts/UserContext";
import { SLEEP_ICON_16PX } from "../assets/icons";
import { Link } from "react-router-dom";

function Header() {
  const showMessage = useActionSuccessMessageStore.getState().showMessage;
  const { profile } = useUserContext();

  const userIcon = profile?.images?.[1]?.url ?? "/img/dummy-user.jpg";
  const userName = profile?.display_name || "A A";

  return (
    <header className="sidebar-header">
      <h1 className="sidebar-header__logo">
        <Link to="/">音楽プレイヤー</Link>
      </h1>
      <div className="sidebar-header__user">
        <img src={userIcon} alt="" className="sidebar-header__user-icon" />
        <p className="sidebar-header__user-name">{userName}</p>
      </div>
      <SearchBar />
      <nav className="sidebar-header__nav">
        <ul className="sidebar-header__list">
          <li className="sidebar-header__item">
            <Link className="sidebar-header__link" to="/">
              <img src="/img/ホームアイコン (1).png" alt="" className="sidebar-header__item-icon" />
              ホーム
            </Link>
          </li>
          <li className="sidebar-header__item">
            <Link className="sidebar-header__link" to="/playlist">
              <img src="/img/ソングリストアイコン1 (1).png" alt="" className="sidebar-header__item-icon" />
              プレイリスト
            </Link>
          </li>

          <li className="sidebar-header__item">
            <Link className="sidebar-header__link" to="/sleep">
              <img src={SLEEP_ICON_16PX} alt="" className="sidebar-header__item-icon" />
              スリープ曲一覧
            </Link>
          </li>

          <LocalFileImportNav />

          <li className="sidebar-header__item">
            <button
              className="sidebar-header__link"
              onClick={() => {
                showMessage("未実装");
              }}
            >
              <img src="/img/無料の設定歯車アイコン (1).png" alt="" className="sidebar-header__item-icon" />
              設定
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
